module.exports = __webpack_public_path__ + "static/artist-marketing-hero-9c7ad11f037561aabfcb6e786b334628.png";